const arrangeShippingCalculators = () => {
  document
    .querySelectorAll('.cart-summary .shop_table tr.shipping')
    .forEach((shippingRow) => {
      const calculator = shippingRow.querySelector(
        '.woocommerce-shipping-calculator'
      );

      if (!calculator) return;

      const calculatorRow = document.createElement('tr');
      const calculatorCell = document.createElement('td');

      calculatorRow.className = 'cart-summary__shipping-calculator';
      calculatorCell.colSpan = 2;
      calculatorCell.append(calculator);
      calculatorRow.append(calculatorCell);
      shippingRow.insertAdjacentElement('afterend', calculatorRow);

      const toggle = calculator.querySelector('.shipping-calculator-button');
      const form = calculator.querySelector('.shipping-calculator-form');

      if (!toggle || !form || toggle.dataset.cartToggleInitialized === 'true') {
        return;
      }

      toggle.dataset.cartToggleInitialized = 'true';
      toggle.setAttribute(
        'aria-expanded',
        toggle.getAttribute('aria-expanded') === 'true' ? 'true' : 'false'
      );
      form.style.removeProperty('display');

      let calculatorAnimation = null;

      const clearAnimationStyles = () => {
        form.style.removeProperty('height');
        form.style.removeProperty('opacity');
        form.style.removeProperty('overflow');
        form.style.removeProperty('margin-top');
        form.classList.remove('is-closing');
      };

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        calculatorAnimation?.cancel();
        calculatorAnimation = null;
        clearAnimationStyles();

        if (reduceMotion) {
          toggle.setAttribute('aria-expanded', String(willExpand));
          return;
        }

        if (willExpand) {
          toggle.setAttribute('aria-expanded', 'true');
        } else {
          form.classList.add('is-closing');
          toggle.setAttribute('aria-expanded', 'false');
        }

        const expandedHeight = form.scrollHeight;
        const expandedMargin = window.getComputedStyle(form).marginTop;

        form.style.overflow = 'hidden';
        calculatorAnimation = form.animate(
          willExpand
            ? [
                { height: '0', marginTop: '0', opacity: 0 },
                {
                  height: `${expandedHeight}px`,
                  marginTop: expandedMargin,
                  opacity: 1,
                },
              ]
            : [
                {
                  height: `${expandedHeight}px`,
                  marginTop: expandedMargin,
                  opacity: 1,
                },
                { height: '0', marginTop: '0', opacity: 0 },
              ],
          {
            duration: willExpand ? 320 : 240,
            easing: willExpand
              ? 'cubic-bezier(0.22, 1, 0.36, 1)'
              : 'cubic-bezier(0.4, 0, 1, 1)',
          }
        );

        calculatorAnimation.onfinish = () => {
          clearAnimationStyles();
          calculatorAnimation = null;
        };
      });
    });
};

const triggerCartFragmentsRefresh = () => {
  if (!window.jQuery) return;

  window.jQuery(document.body).trigger('updated_wc_div');
  window.jQuery(document.body).trigger('wc_fragment_refresh');
};

const replaceCartContent = async (response) => {
  if (!response.ok) {
    throw new Error(`Cart request failed: ${response.status}`);
  }

  const responseDocument = new DOMParser().parseFromString(
    await response.text(),
    'text/html'
  );
  const currentContent = document.querySelector('.cart-page__content');
  const updatedContent = responseDocument.querySelector('.cart-page__content');

  if (!currentContent || !updatedContent) {
    throw new Error('Updated cart markup was not found');
  }

  currentContent.replaceWith(document.importNode(updatedContent, true));
  initCart();
  triggerCartFragmentsRefresh();
};

const renderCouponNotices = (html, fallbackMessage) => {
  const notices = document.querySelector('.woocommerce-notices-wrapper');

  if (!notices) return;

  const responseDocument = new DOMParser().parseFromString(html, 'text/html');
  const responseNotices = responseDocument.querySelectorAll(
    '.woocommerce-error, .woocommerce-message, .woocommerce-info'
  );

  if (responseNotices.length) {
    notices.replaceChildren(
      ...Array.from(responseNotices, (notice) =>
        document.importNode(notice, true)
      )
    );
  } else {
    const error = document.createElement('ul');
    const errorItem = document.createElement('li');

    error.className = 'woocommerce-error';
    error.setAttribute('role', 'alert');
    error.tabIndex = -1;
    errorItem.textContent = fallbackMessage;
    error.append(errorItem);
    notices.replaceChildren(error);
  }

  notices
    .querySelector(
      '.woocommerce-error, .woocommerce-message, .woocommerce-info'
    )
    ?.focus({ preventScroll: true });
};

const handleCouponSubmit = async (event) => {
  const couponForm = event.target.closest?.('.cart-summary__coupon');

  if (!couponForm) return;

  event.preventDefault();
  event.stopPropagation();

  if (couponForm.classList.contains('is-updating')) return;

  const submitButton = couponForm.querySelector('[name="apply_coupon"]');
  const couponInput = couponForm.querySelector('[name="coupon_code"]');
  const fallbackMessage =
    couponForm.dataset.ajaxError ||
    'Unable to apply the promotional code. Please try again.';
  const cartParams = window.wc_cart_params;

  couponForm.classList.add('is-updating');
  couponForm.setAttribute('aria-busy', 'true');

  if (submitButton) submitButton.disabled = true;

  try {
    if (!cartParams?.wc_ajax_url || !cartParams.apply_coupon_nonce) {
      throw new Error('WooCommerce cart AJAX parameters are unavailable');
    }

    const wooEndpoint = new URL(
      cartParams.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon'),
      window.location.href
    );
    const requestUrl = new URL(
      `${wooEndpoint.pathname}${wooEndpoint.search}`,
      window.location.origin
    );
    const requestBody = new URLSearchParams({
      coupon_code: couponInput?.value || '',
      security: cartParams.apply_coupon_nonce,
    });
    const couponResponse = await fetch(requestUrl, {
      method: 'POST',
      body: requestBody,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!couponResponse.ok) {
      throw new Error(`Coupon request failed: ${couponResponse.status}`);
    }

    const couponNotices = await couponResponse.text();
    const cartResponse = await fetch(window.location.href, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    await replaceCartContent(cartResponse);
    renderCouponNotices(couponNotices, fallbackMessage);
  } catch {
    couponForm.classList.remove('is-updating');
    couponForm.removeAttribute('aria-busy');

    if (submitButton) submitButton.disabled = false;

    renderCouponNotices('', fallbackMessage);
  }
};

let cartSort = null;

const sortCartProducts = (cartForm) => {
  if (!cartSort) return;

  const list = cartForm.querySelector('.cart-products__list');

  if (!list) return;

  const items = Array.from(list.querySelectorAll(':scope > .cart-product'));
  const direction = cartSort.direction === 'asc' ? 1 : -1;

  items.sort((first, second) => {
    const firstValue = first.dataset[`sort${cartSort.key}`];
    const secondValue = second.dataset[`sort${cartSort.key}`];

    return (
      direction *
      (cartSort.key === 'Name'
        ? firstValue.localeCompare(
            secondValue,
            document.documentElement.lang || undefined,
            {
              numeric: true,
              sensitivity: 'base',
            }
          )
        : Number(firstValue) - Number(secondValue))
    );
  });
  items.forEach((item) => list.append(item));
  cartForm.querySelectorAll('[data-cart-sort]').forEach((button) => {
    const active = button.dataset.cartSort === cartSort.key.toLowerCase();

    button.setAttribute('aria-pressed', String(active));
    button.querySelector('.cart-products__sort-direction').textContent = active
      ? cartSort.direction === 'asc'
        ? '↑'
        : '↓'
      : '';
  });
};

const initCart = () => {
  arrangeShippingCalculators();
  initClearCart();

  const cartForm = document.querySelector('.woocommerce-cart-form');

  if (!cartForm || cartForm.dataset.cartInitialized === 'true') return;

  cartForm.dataset.cartInitialized = 'true';
  sortCartProducts(cartForm);
  let updateTimer = null;
  let focusTarget = null;

  const submitWithPageReload = (updateButton) => {
    let fallbackInput = cartForm.querySelector(
      'input[type="hidden"][name="update_cart"]'
    );

    if (!fallbackInput) {
      fallbackInput = document.createElement('input');
      fallbackInput.type = 'hidden';
      fallbackInput.name = 'update_cart';
      cartForm.append(fallbackInput);
    }

    fallbackInput.value = updateButton.value || 'Update cart';
    HTMLFormElement.prototype.submit.call(cartForm);
  };

  const restoreFocus = () => {
    if (!focusTarget) return;

    const input = Array.from(
      document.querySelectorAll('.woocommerce-cart-form input.qty')
    ).find((element) => element.name === focusTarget.inputName);
    const button = input
      ?.closest('[data-cart-quantity]')
      ?.querySelector(focusTarget.buttonSelector);

    button?.focus({ preventScroll: true });
  };

  const refreshCart = async (updateButton) => {
    const formData = new FormData(cartForm);
    const formAction = new URL(cartForm.action, window.location.href);
    const requestUrl = new URL(
      `${formAction.pathname}${formAction.search}`,
      window.location.origin
    );

    formData.set('update_cart', updateButton.value || 'Update cart');
    cartForm.classList.add('is-updating');
    cartForm.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(requestUrl, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      await replaceCartContent(response);
      restoreFocus();
    } catch {
      submitWithPageReload(updateButton);
    }
  };

  const scheduleUpdate = (input, buttonSelector) => {
    const updateButton = cartForm.querySelector('[name="update_cart"]');

    if (!updateButton) return;

    focusTarget = input?.name
      ? {
          inputName: input.name,
          buttonSelector,
        }
      : null;
    window.clearTimeout(updateTimer);
    updateButton.disabled = false;

    updateTimer = window.setTimeout(() => {
      refreshCart(updateButton);
    }, 500);
  };

  cartForm.addEventListener('click', (event) => {
    const sortButton = event.target.closest('[data-cart-sort]');

    if (sortButton) {
      const key = sortButton.dataset.cartSort;
      const normalizedKey = key.charAt(0).toUpperCase() + key.slice(1);

      cartSort = {
        key: normalizedKey,
        direction:
          cartSort?.key === normalizedKey && cartSort.direction === 'asc'
            ? 'desc'
            : 'asc',
      };
      sortCartProducts(cartForm);
      return;
    }

    const button = event.target.closest(
      '[data-quantity-decrease], [data-quantity-increase]'
    );

    if (!button) return;

    const quantity = button.closest('[data-cart-quantity]');
    const input = quantity?.querySelector('input.qty');

    if (!input) return;

    const step = Number.parseFloat(input.step) || 1;
    const min = input.min === '' ? 0 : Number.parseFloat(input.min);
    const max = input.max === '' ? Infinity : Number.parseFloat(input.max);
    const current = Number.parseFloat(input.value) || 0;
    const direction = button.hasAttribute('data-quantity-increase') ? 1 : -1;
    const next = Math.min(max, Math.max(min, current + direction * step));

    if (next === current) return;

    input.value = String(next);
    scheduleUpdate(
      input,
      direction > 0 ? '[data-quantity-increase]' : '[data-quantity-decrease]'
    );
  });

  cartForm.addEventListener('change', (event) => {
    if (event.target.matches('input.qty')) {
      scheduleUpdate(event.target, 'input.qty');
    }
  });
};

const initClearCart = () => {
  const dialog = document.querySelector('.cart-clear-dialog');
  const opener = document.querySelector('[data-cart-clear]');

  if (!dialog || !opener || dialog.dataset.initialized) return;

  dialog.dataset.initialized = 'true';
  const cancel = dialog.querySelector('[data-cart-clear-cancel]');
  const confirm = dialog.querySelector('[data-cart-clear-confirm]');

  opener.addEventListener('click', () => dialog.showModal());
  cancel.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener.focus({ preventScroll: true }));
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog || dialog.getAttribute('aria-busy') === 'true')
      return;

    const bounds = dialog.getBoundingClientRect();

    if (
      event.clientX < bounds.left ||
      event.clientX > bounds.right ||
      event.clientY < bounds.top ||
      event.clientY > bounds.bottom
    )
      dialog.close();
  });
  dialog.addEventListener('cancel', (event) => {
    if (dialog.getAttribute('aria-busy') === 'true') event.preventDefault();
  });
  confirm.addEventListener('click', async () => {
    const error = dialog.querySelector('.cart-clear-dialog__error');
    const endpoint = new URL(dialog.dataset.endpoint, window.location.href);
    const requestUrl = new URL(
      endpoint.pathname + endpoint.search,
      window.location.origin
    );

    confirm.disabled = true;
    cancel.disabled = true;
    error.hidden = true;
    dialog.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(requestUrl, {
        method: 'POST',
        credentials: 'same-origin',
        body: new URLSearchParams({ security: dialog.dataset.nonce }),
      });

      if (!response.ok || !(await response.json()).success)
        throw new Error('Cart clearing failed');

      const cartResponse = await fetch(window.location.href, {
        credentials: 'same-origin',
      });

      await replaceCartContent(cartResponse);
      dialog.close();
      document
        .querySelector('.cart-empty-state__button')
        ?.focus({ preventScroll: true });
    } catch {
      error.textContent = dialog.dataset.error;
      error.hidden = false;
    } finally {
      confirm.disabled = false;
      cancel.disabled = false;
      dialog.removeAttribute('aria-busy');
    }
  });
};

document.addEventListener('submit', handleCouponSubmit, true);

if ('loading' === document.readyState) {
  document.addEventListener('DOMContentLoaded', initCart);
} else {
  initCart();
}
